// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import EmojiPickerController from "./emoji_picker_controller"
application.register("emoji-picker", EmojiPickerController)

import ClipboardController from "./clipboard_controller"
application.register("clipboard", ClipboardController)

import AnalyticsController from "./analytics_controller"
application.register("analytics", AnalyticsController)

import CookieConsentController from "./cookie_consent_controller"
application.register("cookie-consent", CookieConsentController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SmartAddController from "./smart_add_controller"
application.register("smart-add", SmartAddController)

import PageTransitionController from "./page_transition_controller"
application.register("page-transition", PageTransitionController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import UrlPreviewController from "./url_preview_controller"
application.register("url-preview", UrlPreviewController)

import ViddyController from "./viddy_controller"
application.register("viddy", ViddyController)

import RsvpChangeController from "./rsvp_change_controller"
application.register("rsvp-change", RsvpChangeController)
